export const SITE_TITLE = "Clyde Wind Ensemble";
export const SITE_DESCRIPTION = "Scotland's Leading Community Concert Band";

export const CONTACT_INFO = {
  email: "contact@clydewindensemble.org",
  phone: ["07977 658616", "07725 555024"],
  rehearsals: {
    day: "Thursday",
    time: "7pm - 9pm",
    location: "Calderglen High School, East Kilbride, G74 2LP"
  }
};

// Mock data for gallery (to be replaced with actual content)
export const GALLERY_PHOTOS = [
  {
    id: 1,
    title: "Band performance",
    src: "https://images.unsplash.com/photo-1511192336575-5a79af67a629?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 2,
    title: "Band rehearsal",
    src: "https://images.unsplash.com/photo-1621784166258-c3bfd1f97290?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 3,
    title: "Concert venue",
    src: "https://images.unsplash.com/photo-1507838153414-b4b713384a76?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 4,
    title: "Wind section",
    src: "https://images.unsplash.com/photo-1508025524947-9a5cac0492a3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 5,
    title: "Percussion section",
    src: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 6,
    title: "Concert audience",
    src: "https://images.unsplash.com/photo-1583411771738-be143664847a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80"
  }
];

export const VIDEO_CONTENT = [
  {
    id: 1,
    title: "Christmas Concert 2023",
    description: "Recorded at Calderglen High School",
    youtubeId: "dQw4w9WgXcQ" // This would be replaced with actual YouTube video ID
  },
  {
    id: 2,
    title: "NCBF Performance Highlights",
    description: "National Concert Band Festival",
    youtubeId: "dQw4w9WgXcQ" // This would be replaced with actual YouTube video ID
  }
];

export const AUDIO_CONTENT = [
  {
    id: 1,
    title: "Fanfare for the Common Man",
    description: "Recorded at Spring Concert 2023",
    soundcloudUrl: "https://soundcloud.com/example/fanfare" // This would be replaced with actual SoundCloud URL
  },
  {
    id: 2,
    title: "Festive Overture",
    description: "Recorded at NCBF 2022",
    soundcloudUrl: "https://soundcloud.com/example/festive" // This would be replaced with actual SoundCloud URL
  }
];

export const EVENTS = [
  {
    id: 1,
    title: "Scottish Concert Band Festival",
    date: "Sunday 1st December",
    time: null,
    location: "Carlibar Primary School",
    image: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    details: null
  },
  {
    id: 2,
    title: "Christmas Concert",
    date: "Thursday 19th December",
    time: "7pm",
    location: "Calderglen High School",
    image: "https://images.unsplash.com/photo-1482361046637-0226fdcfa3b7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    details: null
  },
  {
    id: 3,
    title: "Children's Concert",
    date: "Saturday 10th May 2025",
    time: "2pm",
    location: "Venue to be announced",
    image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    details: null
  }
];
